<template>
  <div class="m-1">
    <div class="row justify-content-center">
      <div class="col-4">
        <PatientInfo v-if="patientcheckup != null" :patient="patientcheckup.patient"/>
      </div>
      <div  class="col-8">
        <div v-if="getCallInfo != null">
          <CallWindow/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import PatientInfo from "@/components/doctor/PatientInfo/PatientInfo";
import CallWindow from "@/components/doctor/CallWindow/CallWindow";
import CheckupService from "@/services/checkup.service";

export default {
  name: "Checkup",
  components: {
    PatientInfo,
    CallWindow,
  },
  data: function () {
    return {
      patientcheckup: null,
    }
  },
  computed: {
    ...mapGetters('doctorCheckup', ['getCallInfo']),
  },
  methods: {
    ...mapActions('doctorCheckup', ['setCallInfo']),
    fetchPatientcheckupDetails() {
      CheckupService.fetchPatientCheckupDetails(this.$route.params.patientcheckup_code)
          .then((response) => {
            if (response.status === 200) {
              this.patientcheckup = response.data;
              console.log(this.patientcheckup);
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
    initializeCall() {
      // Request a new token
      CheckupService.makeCheckupCall(this.$route.params.patientcheckup_code, false)
          .then((response) => {
            if (response.status === 201) {
              this.setCallInfo(response.data);
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
  },
  mounted() {
    this.fetchPatientcheckupDetails();
    if (this.getCallInfo == null){
      this.initializeCall();
    }
  }
}
</script>

<style src="./Checkup.scss" lang="scss">

</style>
